<template>
	<div class="car-manage">
		<!-- <div class="headCarAdd">
		  	<i class="el-icon-setting"></i>&nbsp;&nbsp;安装包下载管理
		</div> -->
		
		<div class="filter-container">
			<el-date-picker v-model="listQuery.time" type="date"
				placeholder="请选择日期" value-format="yyyy-MM-dd">
			</el-date-picker>
			<el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px"
			  @click="handleFilter(true)">
			  搜索
			</el-button>
			
			<el-button type="success" @click="handleAdd()">
				新增
			</el-button>	
		</div>
		
		<el-table :data="listData" v-loading="listLoading" border highlight-current-row style="width: 100%; align: center">
			<el-table-column prop="alarmCode" label="告警编码" align="center">
			</el-table-column>
			<el-table-column prop="alarmName" label="告警名称" align="center">
			</el-table-column>
			<el-table-column prop="alarmStatusStr" label="是否推送" align="center">
			</el-table-column>
			<el-table-column prop="operator" label="操作" align="center" >
				<template v-slot:="{row,$index}">
					<el-button type="primary" size="mini" @click="handleEdit(row)">
						编辑
					</el-button>	
					<el-button type="danger" size="mini" @click="handleDelete(row)">
						删除
					</el-button>	
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页栏 -->
		<pagination :total="totalCounts" @pagination="handlePageChange">
		</pagination>
		
		
		<!-- 编辑用户dialog -->
		<el-dialog title="编辑告警" :visible.sync="dialogFormVisible" :before-close="handleClose">
		  <el-form :model="editAlarm" ref="editAlarmInfo" label-width="120px">
		
		    <el-form-item label="告警编码" prop="alarmCode">
		      <el-input v-model="editAlarm.alarmCode" placeholder="请输入告警编码" ></el-input>
		    </el-form-item>
			
			<el-form-item label="告警名称" prop="alarmName">
			  <el-input v-model="editAlarm.alarmName" placeholder="请输入告警名称" ></el-input>
			</el-form-item>
			
			<el-form-item label="告警推送" prop="wechatStatus">
				<el-select v-model="editAlarm.alarmStatus" placeholder="是否推送" style="width:100%" >
					<el-option v-for="(item,index) in statusOptions" :key="index" :label="item" :value="index">
					</el-option>
				</el-select>
			</el-form-item>
		    
		  </el-form>
		  <div slot="footer" class="dialog-footer">
		    <el-button @click="cancelEditAlarm()">取 消</el-button>
		    <el-button type="primary" @click="editAlarmForm()">确 定</el-button>
		  </div>
		</el-dialog>
		
	</div>
</template>

<script>
	import Pagination from '@/components/common/Pagination'
	import {formatDate} from '@/utils/date'
	import {alarmList,updateAlarm,deleteAlarm} from '@/api/warning.js'
	
	export default {
		name: 'AlarmManage',
		components: {
		    Pagination,
		},
		data(){
		    return{
		        listLoading: true,
		        listData: [],
		        totalCounts: 0,
		        listQuery: {
		            pageIndex: 1,
		            pageSize: 10,
		            params: {
		                alarm_code:'',
						alarm_name:'',
						alarm_status:''
		            },
		            fuzzySearch: true,
		        },
				dialogFormVisible: false,
				editAlarm: {
				  id:null,
				  alarmCode: '',  
				  alarmName: '',
				  alarmStatus:''
				},
				statusOptions:{
					0:"是",
					1:"否"
				}
		    }//-return
		},
		methods:{
			handleFilter() {
			    this.listLoading = true
			    alarmList(this.listQuery).then(res => {
			        let data = res.data
			        this.totalCounts = res.count
			        // 对后端数据进行解析
			        this.listData = data.map(item => {
						item.alarmStatusStr =  item.alarmStatus === 0 ? '是' : '否'
			            return item
			        })
			        this.listLoading = false
			    })
			},
			handlePageChange(data) {
			    this.listQuery.pageIndex = data.page
			    this.listQuery.pageSize = data.limit
			    this.handleFilter()
			},
			handleAdd(){			
				// this.$refs.editAlarm.resetFields();
				this.dialogFormVisible = true
			},
			handleClose(done) {
			  this.$confirm('确认关闭？')
			    .then(_ => {
			      done();
			      this.cancelEditUser();
			    })
			    .catch(_ => {});
			
			},
			handleEdit(row){
				this.editAlarm.id = row.id;
				//设置用户所属单位
				this.editAlarm.alarmCode = row.alarmCode;
				this.editAlarm.alarmName = row.alarmName;
				this.editAlarm.alarmStatus = row.alarmStatus+ ""
				this.dialogFormVisible = true;
			},
			cancelEdit() {
			  this.dialogFormVisible = false
			  // this.$refs.editAlarm.resetFields();
			  console.log(this.editAlarm)
			},
			editAlarmForm(){
				if(this.editAlarm.id != null){
					this.editAlarm.id = parseInt(this.editAlarm.id )
				}
				if(this.editAlarm.alarmStatus != null){
					this.editAlarm.alarmStatus = parseInt(this.editAlarm.alarmStatus )
				}
				updateAlarm(this.editAlarm).then(res => {
				  if (res.result === "1") {
				    this.$message({
				      message: res.message,
				      type: 'success'
				    })
				
				    //刷新列表数据
				    this.handleFilter()
				    //隐藏添加用户模态框
				    this.dialogFormVisible = false;
				    //重置用户表单数据
				    // this.$refs.editAlarm.resetFields();
				  } else {
				    this.$message.error(res.message)
				  }  
				})
			},
			handleDelete(row){
				this.$confirm('此操作将永久删除该告警, 是否继续?', '提示', {
				  confirmButtonText: '确定',
				  cancelButtonText: '取消',
				  type: 'warning'
				}).then(() => {
				  deleteAlarm(row.id).then(res => {
				    if (res.result === "1") {
				      this.$message({
				        message: res.message,
				        type: 'success'
				      })
				      this.handleFilter()
				    } else {
				      this.$message.error(res.message)
				    }
				  })
				}).catch(() => {
				  this.$message({
				    type: 'info',
				    message: '已取消删除'
				  });
				});
			}
		}, //-methods
		mounted(){
		    this.handleFilter()
		},
	///	
	}
	
</script>

<style>
.headCarAdd{
		background-color:#3fb976;
		width:100%;
		height:50px;
		color:#FFFFFF;
		line-height:50px;
		padding-left: 15px;
		border-radius: 10px;
	}
</style>
